export class Book{

    id:string
    name:string
    image:any
    link:string

    get imageUrl():string{
        return this.image.fileUrl;
    }

}